'use client';

import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { type ReactNode } from 'react';
import { usePathname } from '../../i18n/i18n-navigation';
import { type LocalPaths } from '../../utils/data/get-local-paths';
import { handleGTMHeaderClickEvent } from '../../utils/helpers/gtm-header-click-event-handler';
import { hasCurrentRouteSubMenu } from '../../utils/helpers/has-current-route-sub-menu';
import { type LanguagesContent } from '../../utils/hooks/get-languages-content-cached';
import { type NavigationItem } from '../../utils/types/navigation-items';
import { ContentContainer } from '../content-container/content-container';
import { HeaderContentMobile } from './components/header-content-mobile/header-content-mobile';
import { HeaderContent } from './components/header-content/header-content';
import { ImpersonationModalProvider } from './components/impersonation-modal/impersonation-modal-context';
import { type HeaderAccountDropdownContent } from './graphql/get-header-profile-dropdown-content';
import { isHeaderSecondaryTheme } from './utils/hooks/is-header-secondary-theme';
import styles from './header.module.scss';
type HeaderClientProps = {
  headerContentProps: {
    homeLabel: string;
    languagesCmsContent: LanguagesContent;
    locale: string;
    profileDropdownCmsContent: HeaderAccountDropdownContent;
    profileDropdownSlot: ReactNode;
    profileDropdownSummarySlot: ReactNode;
    statusChipSlot: ReactNode;
  };
  isSecondaryThemeInitial: boolean;
  navigationItems: NavigationItem[];
  paths: LocalPaths;
};
export const HeaderClient = t0 => {
  const $ = _c(18);
  const {
    headerContentProps,
    isSecondaryThemeInitial,
    navigationItems,
    paths
  } = t0;
  const pathname = usePathname();
  let isSecondaryTheme;
  let t1;
  if ($[0] !== isSecondaryThemeInitial || $[1] !== navigationItems || $[2] !== pathname || $[3] !== paths) {
    const hasSubMenu = hasCurrentRouteSubMenu(pathname, navigationItems);
    const isSecondaryThemeClient = isHeaderSecondaryTheme({
      pathname,
      paths
    });
    isSecondaryTheme = isSecondaryThemeClient === isSecondaryThemeInitial ? isSecondaryThemeInitial : isSecondaryThemeClient;
    t1 = classNames(styles["header-wrapper"], {
      [styles["header-wrapper--has-sub-menu"]]: hasSubMenu,
      [styles["header-wrapper--secondary"]]: isSecondaryTheme
    });
    $[0] = isSecondaryThemeInitial;
    $[1] = navigationItems;
    $[2] = pathname;
    $[3] = paths;
    $[4] = isSecondaryTheme;
    $[5] = t1;
  } else {
    isSecondaryTheme = $[4];
    t1 = $[5];
  }
  let t2;
  let t3;
  if ($[6] !== headerContentProps || $[7] !== isSecondaryTheme || $[8] !== navigationItems) {
    t2 = <HeaderContentMobile isSecondaryTheme={isSecondaryTheme} navigationItems={navigationItems} {...headerContentProps} />;
    t3 = <HeaderContent isSecondaryTheme={isSecondaryTheme} navigationItems={navigationItems} {...headerContentProps} />;
    $[6] = headerContentProps;
    $[7] = isSecondaryTheme;
    $[8] = navigationItems;
    $[9] = t2;
    $[10] = t3;
  } else {
    t2 = $[9];
    t3 = $[10];
  }
  let t4;
  if ($[11] !== headerContentProps.profileDropdownCmsContent || $[12] !== t2 || $[13] !== t3) {
    t4 = <ContentContainer><header className={styles.header} id="header" onAuxClick={handleGTMHeaderClickEvent} onClick={handleGTMHeaderClickEvent}><ImpersonationModalProvider cmsContent={headerContentProps.profileDropdownCmsContent}>{t2}{t3}</ImpersonationModalProvider></header></ContentContainer>;
    $[11] = headerContentProps.profileDropdownCmsContent;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t1 || $[16] !== t4) {
    t5 = <div className={t1}>{t4}</div>;
    $[15] = t1;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
};